
import { supabase } from '@/integrations/supabase/client';
import { SubscriptionCreate, SubscriptionUpdate } from '@/services/types/subscriptionTypes';

// Создание новой подписки
export const createSubscription = async (subscription: SubscriptionCreate) => {
  try {
    const { data, error } = await supabase
      .from('subscriptions')
      .insert(subscription)
      .select()
      .single();

    if (error) {
      console.error('Ошибка при создании подписки:', error);
      return { data: null, error: error.message };
    }

    return { data, error: null };
  } catch (err: any) {
    console.error('Непредвиденная ошибка при создании подписки:', err);
    return { data: null, error: err.message };
  }
};

// Отмена подписки
export const cancelSubscription = async (id: string) => {
  try {
    const { data, error } = await supabase
      .from('subscriptions')
      .update({ status: 'cancelled' })
      .eq('id', id)
      .select();

    if (error) {
      console.error('Ошибка при отмене подписки:', error);
      return { data: null, error: error.message };
    }

    return { data, error: null };
  } catch (err: any) {
    console.error('Непредвиденная ошибка при отмене подписки:', err);
    return { data: null, error: err.message };
  }
};

// Получение подписки по ID
export const getSubscriptionById = async (id: string) => {
  try {
    const { data, error } = await supabase
      .from('subscriptions')
      .select('*')
      .eq('id', id)
      .single();

    if (error) {
      console.error('Ошибка при получении подписки:', error);
      return { data: null, error: error.message };
    }

    return { data, error: null };
  } catch (err: any) {
    console.error('Непредвиденная ошибка при получении подписки:', err);
    return { data: null, error: err.message };
  }
};

// Экспортируем функции из subscriptionUpdate.ts
export { updateSubscription, updateSubscriptionStatus, deleteSubscription } from './subscriptionUpdate';

// Экспортируем функции из subscriptionCourier.ts и subscriptionFetch.ts
export { fetchCourierSubscriptions, fetchCourierSubscriptionsByPhone } from './subscriptionFetch';
